/******************************
  GLOBAL CART ADD FUNCTION
******************************/
window.myGlobalFunction = function (fromWhere, items) {
  console.log("myGlobalFunction called:", fromWhere, items);

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(resolve)
        .catch(reject);
    }, 100);
  });
};


document.addEventListener("DOMContentLoaded", () => {
  /* ----------------------
      TAB SWITCH HANDLER
  ----------------------- */
  const tabs          = document.querySelectorAll(".twining-tab li");
  const product1Block = document.querySelector(".female-product-block");
  const product2Block = document.querySelector(".male-product-block");

  // Save original required attributes
  document.querySelectorAll(".female-product-block [required], .male-product-block [required]")
    .forEach(el => el.dataset.originalRequired = "true");

  function activateTab(tabName) {
    const showProduct1 = tabName === "product1";

    tabs[0].classList.toggle("active", showProduct1);
    tabs[1].classList.toggle("active", !showProduct1);

    product1Block.classList.toggle("active", showProduct1);
    product2Block.classList.toggle("active", !showProduct1);

    const visible = showProduct1 ? product1Block : product2Block;
    const hidden  = showProduct1 ? product2Block : product1Block;

    hidden.querySelectorAll("[required]").forEach(el => el.removeAttribute("required"));
    visible.querySelectorAll("[data-original-required='true']").forEach(el => {
      el.setAttribute("required", "required");
    });
  }

  tabs[0].addEventListener("click", () => activateTab("product1"));
  tabs[1].addEventListener("click", () => activateTab("product2"));

  activateTab("product1");
  const isMadeToOrder = document.querySelector('.product-form__input input[type=radio][value="Made to Order"]');
  if(isMadeToOrder && isMadeToOrder.checked) {
    document.querySelector('[js-made-to-order-outfit-wrapper]').classList.remove('hide');
  }

  /* ----------------------
      FORM LOGIC
  ----------------------- */
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const firstProduct1Radio      = form.querySelector('input[name="Size-Product1"]');
  const firstProduct1RadioLabel = form.querySelector('.product-form__input_wrap:first-child input[name="Size-Product1"] + label');
  // if (firstProduct1Radio) firstProduct1RadioLabel.click();

  form.addEventListener("change", (e) => {
    const target       = e.target;
    const isStitched   = target.value === "Stitched";
    const isUnstitched = target.value === "Unstitched";
    const isMadeToOrder = target.value === "Made to Order";
    if (isUnstitched && firstProduct1Radio) {
      firstProduct1Radio.checked = true;
      firstProduct1RadioLabel.click();
      activateTab("product1");
      return;
    }
    if (isStitched) {
      firstProduct1Radio.checked = false;
      return;
    }
    if (target.name === "Size-Product2") {
      activateTab("product2");
      return;
    }
    if (target.name === "Size-Product1") {
      activateTab("product1");
      return;
    }
  });


  /* ---------------------------------------
      UNIVERSAL PROPERTY EXTRACTOR
  --------------------------------------- */
  function getItemProperties(form, itemIndex) {
    const props = {};

    const selector = `input[name^="items[${itemIndex}][properties"]:not(.blouse-style-input), input[name^="items[${itemIndex}][properties"].blouse-style-input:checked, select[name^="items[${itemIndex}][properties"]`;

    form.querySelectorAll(selector).forEach(input => {
      if (input.disabled) return;

      const match = input.name.match(new RegExp(`items\\[${itemIndex}\\]\\[properties\\]\\[(.+?)\\]`));
      if (!match) return;

      const key = match[1].trim();
      const value = input.value.trim();

      // Skip empty properties
      if (value === "") return;

      props[key] = input.value;
    });

    return props;
  }


  /* ----------------------
      ADD TO CART LOGIC
  ----------------------- */
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const requiredFields = form.querySelectorAll("[data-original-required='true']");
    for (const el of requiredFields) {
      if (el.value.trim() === "") {
        activateTab("product1");
        return;
      }
    }

    const requiredOptionSelects      = form.querySelectorAll('[js-custom-option-select][js-required-property-field]');
    const stitchedSelectedCheckField = form.querySelector('[js-custom-variant-selects] input[value="Stitched"]:checked');
    const blouseInput                = form.querySelector('#blouse-style-input');

    const isAnySelectSelected = Array.from(requiredOptionSelects).some(
      select => select.value && select.value.trim() !== ''
    );
    if (!isAnySelectSelected && stitchedSelectedCheckField) {
      activateTab("product1");
      if (requiredOptionSelects) {
        requiredOptionSelects.forEach(selectBox => {
          selectBox.setAttribute('required', 'true');
        });
      }
      return;
    }
    if (blouseInput) {
      const isBlouseFilled = blouseInput && blouseInput.value && blouseInput.value.trim() !== '';
      if (!isBlouseFilled && stitchedSelectedCheckField) {
        activateTab("product1");
        blouseInput.setAttribute('required', 'true');
        return;
      }
    }

    const product1Input = form.querySelector('input[name="Size-Product1"]:checked');
    const product2Input = form.querySelector('input[name="Size-Product2"]:checked');

    if (!product1Input) { activateTab("product1"); return; }
    if (!product2Input) { activateTab("product2"); return; }

    const product1VariantId = Number(form.querySelector(`label[for="${product1Input.id}"]`).getAttribute("varid"));
    const product2VariantId = Number(form.querySelector(`label[for="${product2Input.id}"]`).getAttribute("varid"));

    console.log('window.upsellRefTimeStamp', window.upsellRefTimeStamp);
    const refTimeStamp = window.upsellRefTimeStamp || Date.now();

    // Product 1 properties (items[0])
    const product1Props  = getItemProperties(form, 0);
    const upsellProducts = form.querySelectorAll('[js-upsell-product] input:checked');
    if (upsellProducts.length > 0) {
      product1Props["_ref_id"] = refTimeStamp;
    }
    product1Props["_ref_id"] = refTimeStamp;

    // Product 2 properties (items[1])
    const product2Props = getItemProperties(form, 1);
    product2Props["_ref_id"] = refTimeStamp;

    const items = [
      {
        id: product1VariantId,
        // quantity: 1,
        properties: product1Props
      },
      {
        id: product2VariantId,
        // quantity: 1,
        ...(Object.keys(product2Props).length ? { properties: product2Props } : {})
      }
    ];

    window.twiningProductItems = items;

    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;

    window.myGlobalFunction("ATC submit", items)
      .then(updateCartSections)
      .catch(() => showError("Error adding products."))
      .finally(() => submitBtn.disabled = false);
  });


  /* ----------------------
      AJAX CART UPDATER
  ----------------------- */
  function updateCartSections() {
    const sectionsToRender = getSectionsToRender();
    const ids = sectionsToRender.map(s => s.id).join(",");

    fetch(`/cart?sections=${ids}`)
      .then(res => res.json())
      .then(data => {
        sectionsToRender.forEach(section => {
          const html = data[section.id];
          if (!html) return;

          const parser = new DOMParser();
          const doc    = parser.parseFromString(html, "text/html");

          let newContent = doc.querySelector(section.selector);
          if (section.id === "cart-icon-bubble") {
            newContent = doc.firstElementChild;
          }

          const container = document.querySelector(section.selector);
          if (newContent && container) {
            container.innerHTML = newContent.innerHTML;
          }
        });

        const drawer = document.querySelector("cart-drawer");
        drawer?.classList.remove("is-empty");
        setTimeout(() => drawer?.open?.(), 100);
      });
  }

  function getSectionsToRender() {
    return [
      { id: "cart-drawer",      selector: "#CartDrawer" },
      { id: "cart-icon-bubble", selector: "#cart-icon-bubble" }
    ];
  }

  function showError(msg) {
    const wrapper = document.querySelector(".product-form__error-message-wrapper");
    const msgEl   = document.querySelector(".product-form__error-message");

    if (wrapper && msgEl) {
      wrapper.hidden    = false;
      msgEl.textContent = msg;
    } else {
      alert(msg);
    }
  }

}); // end DOMContentLoaded

/* ────────────────────────────────────────────────────────────
    INITIAL COMBINED PRICE FROM DOM
    On page load, reads the MRP from the product details price
    element and writes it into [data-combined-price] if the
    hidden spans haven't been populated yet.
───────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {

  const mrpPriceElement    = document.querySelector('.product_details .price__regular .price-item');
  const combinedPriceElement = document.querySelectorAll('[data-combined-price]');
  function formatMoney(num) {
    return num.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  if (mrpPriceElement && combinedPriceElement) {
    combinedPriceElement.forEach(el => {
      el.textContent = mrpPriceElement.textContent.trim();
    });
    const aditionalCostTotal = document.querySelectorAll('#aditional_costtotal');
    aditionalCostTotal.forEach(el => {
      const currencySymbol = document.querySelector('[data-shop-currency]').dataset.shopCurrency
      el.innerText = currencySymbol + formatMoney(mrpPriceElement.getAttribute('data-pdp-product-price'));
    });
  }

});